import React, { useState } from "react";
import style from "./speaker.module.css";
import { Col, Row, Button, Form, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { bookAppoinment } from "../../apis/authApis";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";

const SpeakerRequest = () => {
  const dispatch = useDispatch();
  const [disableButton, setDisableButton] = useState(false);
  const [startDate, setStartDate] = useState();

  const handleCalendlyOpen = () => {
    window.open("https://calendly.com/fundlifeme/speaker-request-planning-session");
  };


  return (
    <div>
      <Helmet>
        <title>Speaker-request - I Stand With The Forgotten Women</title>
        <meta
          name="description"
          content="Inspire your audience with Mike Goss! Book him now for your next event and hear life-changing messages filled with humor, scripture, and personal stories."
        />
        <meta
          property="og:description"
          content="Inspire your audience with Mike Goss! Book him now for your next event and hear life-changing messages filled with humor, scripture, and personal stories."
        />
        <meta
          name="keywords"
          content="online fundraising, online pro-life fundraising, online pregnancy help center fundraising, online maternity home fundraising, online adoption service fundraising"
        />
      </Helmet>
      <div className={style.speaker_banner}>
        <div className="container">
          <Row className="m-0  p-0">
            <Col md={{ span: 10, offset: 2 }}>
              <div className={style.speakerlogotext}>
                <div className={`text-start ${style.logospeaker}`}>
                  <img src="/mainlogo.svg" alt="logo" width={200} />
                </div>
                <div className={style.banner_hd}>
                  Request Mike Goss
                  <br /> to Speak at Your Event!
                </div>
                <div className="mt-3">
                  {" "}
                  <a href="#speakerform">
                    {" "}
                    <button className={`bluebtn ${style.booknowbutton}`} onClick={handleCalendlyOpen} >
                      Book Now
                    </button>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="container">
        <div className={style.speaker_row}>
          <div className="my-5 ">
            <div className={style.speaker_heading}>
              {" "}
             
              {/* Thousands have been inspired to embrace an abundant life
              through one of Mike Goss’s presentations. With a unique
              blend of Scripture, humor, and personal life experiences, Mike
              delivers a powerful and unforgettable message that
              transforms hearts and minds. His story of redemption and
              hope resonates deeply with audiences, leaving a lasting
              impact wherever he speaks. */}
              {/* Thousands have been inspired to embrace abundant life through one
              of Mike Goss presentations. Utilizing Scripture, humor, and the
              story of his life, he communicates life-changing truth in an
              unforgettable way. */}
             
              <div className="" style={{ fontSize: "20px", textAlign:"justify",lineHeight:"30px" }}>
                {" "}
              Mike Goss carries a message of hope that is both compelling and adaptable to any setting. With a unique ability to take a heavy subject and lighten it with well-timed humor, Mike helps audiences engage sensitive and often divisive issues in a way that feels accessible, human, and disarming. Through a blend of Scripture, laughter, and personal life experiences, he delivers presentations that are powerful, engaging, and unforgettable.
              Guests leave feeling both enlightened and encouraged—better equipped to think clearly about complex topics—while also genuinely entertained by Mike’s “laugh-a-minute” delivery. His story of redemption and hope resonates deeply, transforming hearts and renewing minds long after the event ends.
              Mike Goss is available to speak at pregnancy center banquets, church events, conferences, and fundraisers. His presentations are marked by authenticity, compassion, and hope, making him an ideal speaker for any life-affirming gathering.
              
              </div>
            </div>
          </div>
          {/* <div className="my-5">
            <Row className="">
              <Col className="m-auto" md={6}>
                <div className={style.speaker_heading}>
                  Ashley Baldwin, Choices Pregnancy Center{" "}
                </div>
                <div className={style.speaker_text}>
                  “Mike Goss is a seasoned speaker who not only provides great
                  vision and insight into the life issue but weaves in his own
                  redemptive story. He brings a much needed message focusing not
                  on being pro-life, but being pro-abundant life. He also brings
                  in the male’s perspective and this was definitely helpful in
                  reaching our audience. His vision went right along with the
                  new vision of our center and our banquet was a smashing
                  success. So much of the feedback that I received was on Mike
                  Goss and how much our supporters enjoyed hearing him speak. I
                  would HIGHLY recommend having Mike Goss as your next banquet
                  speaker.”
                </div>
              </Col>
              <Col className="" md={6}>
                <div className="text-md-end text-center">
                  <img
                    className="w-100"
                    src="/speaker/crowd.png"
                    alt="story"
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="my-5">
            <Row className="">
              <Col className="" md={6}>
                <div>
                  <img
                    className="w-100"
                    src="/speaker/positive.png"
                    alt="story"
                  />
                </div>
              </Col>
              <Col className="m-auto" md={6}>
                <div className={style.speaker_heading}>
                  Frank Burger, Valley Pregnancy Center Director{" "}
                </div>
                <div className={style.speaker_text}>
                  "Of course, the success of the dinner is not just based on how
                  folks felt when they left that evening or from the feedback we
                  received. The success of the banquet is really measured in the
                  amount of donations received. Our banquet had been raising
                  just under $175,000 for the last few years. Our prayer for
                  2015 was to increase our giving to $200,000 in order to fund
                  another abstinence presenter for our school program. When the
                  dust all settled and our tabulations were complete, God had
                  blessed us, through Mike Goss, to raise over $200,000 for this
                  ministry."
                </div>
              </Col>
            </Row>
          </div> */}

          <div className="my-5 ">
            <div className={style.speaker_heading}>
              Mike Goss is available to speak at your next pregnancy center
              event or banquet, church event, conference, or fundraiser. Book
              now .
            </div>

            <div>
              <Button
                className="w-100 authBlubtn"
                variant="primary"
                type="submit"
                disabled={disableButton}
                onClick={handleCalendlyOpen}

              >
                Book Now
                {disableButton && (
                  <Spinner
                    className="ms-3"
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerRequest;
